export default __webpack_public_path__ + "static/6-tips-for-shopping-while-on-holiday-local-words-03e47436e51a6ba8b66fbc5e13ae57be.jpg";